module.exports = __webpack_public_path__ + "dashboard-icon.png?5509074ea40aaecabeba69681adda217";